import React, { useEffect, useState } from 'react';

import "./stylesheet/page.css"
const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("student");
  const [editUser, setEditUser] = useState(null);

  // ---------- FETCH USERS ----------
  useEffect(() => {
    fetch("https://www.gurukrupaeducation.com/api/get-users.php")
      .then((res) => res.json())
      .then((data) => setUsers(data))
      .catch((err) => console.error("Error pulling database records:", err));
  }, []);

  // ---------- WRITE NEW USER ACTION ----------
  const handleAddUser = async () => {
    if (!name || !email || !password) {
      alert("Please populate all necessary validation items.");
      return;
    }

    const res = await fetch("https://www.gurukrupaeducation.com/api/add-user.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, email, password, role }),
    });

    const data = await res.json();
    if (data.success) {
      alert("User Record Added ✅");
      window.location.reload();
    }
  };

  // ---------- STATE ALLOCATION TO UPDATE EDITOR PANEL ----------
  const handleEdit = (user) => {
    setEditUser(user);
    // Smooth scroll down to modification window context if rendering on smaller viewports
    if (window.innerWidth <= 1024) {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  };

  // ---------- COMMITTING EDITED DATA MODIFICATIONS ----------
  const handleUpdate = async () => {
    const res = await fetch("https://www.gurukrupaeducation.com/api/update-user.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(editUser),
    });

    const data = await res.json();
    if (data.success) {
      alert("User Database Parameters Updated ✅");
      window.location.reload();
    }
  };

  return (
    <div className="dashboard-grid">
      
      {/* ── LEFT UTILITY CONSOLE MODULE STACK ── */}
      <div className="left-stack">
        
        {/* ADD USER CARD */}
        <section className="panel">
          <h2 className="panel-title">➕ Create System User</h2>

          <div className="form">
            <div className="field">
              <label>Full Legal Name</label>
              <input
                type="text"
                className="input"
                placeholder="Ex: Akash Maurya"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="field">
              <label>Email Address</label>
              <input
                type="email"
                className="input"
                placeholder="akash@gurukrupa.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="field">
              <label>Security Password</label>
              <input
                type="password"
                className="input"
                placeholder="Assign dynamic credential token"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <div className="field">
              <label>System Authorization Role</label>
              <select
                className="select"
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <option value="student">Student</option>
                <option value="teacher">Teacher</option>
                <option value="staff">Staff</option>
                <option value="admin">Admin</option>
              </select>
            </div>

            <button type="button" className="add-btn" onClick={handleAddUser}>
              Add Account Record →
            </button>
          </div>
        </section>

        {/* DYNAMIC RECORD CONTEXT LIVE EDIT CARD */}
        {editUser && (
          <section className="panel edit-panel">
            <h2 className="panel-title">✏️ Modify User Account</h2>
            <p className="edit-note">
              Adjust modification scopes for authorization clearance, target name, or routing email configurations.
            </p>

            <div className="form">
              <div className="field">
                <label>Signatory Full Name</label>
                <input
                  type="text"
                  className="input"
                  value={editUser.name || ""}
                  onChange={(e) =>
                    setEditUser({ ...editUser, name: e.target.value })
                  }
                />
              </div>

              <div className="field">
                <label>Routing Email Address</label>
                <input
                  type="email"
                  className="input"
                  value={editUser.email || ""}
                  onChange={(e) =>
                    setEditUser({ ...editUser, email: e.target.value })
                  }
                />
              </div>

              <div className="field">
                <label>Clearance Allocation Layer</label>
                <select
                  className="select"
                  value={editUser.role || "student"}
                  onChange={(e) =>
                    setEditUser({ ...editUser, role: e.target.value })
                  }
                >
                  <option value="student">Student</option>
                  <option value="teacher">Teacher</option>
                  <option value="staff">Staff</option>
                  <option value="admin">Admin</option>
                </select>
              </div>

              <div className="edit-actions">
                <button type="button" className="update-btn" onClick={handleUpdate}>
                  Save Changes
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setEditUser(null)}
                >
                  Dismiss
                </button>
              </div>
            </div>
          </section>
        )}
      </div>

      {/* ── RIGHT DATA LEDGER SHEET SECTION ── */}
      <section className="panel">
        <h2 className="panel-title">👥 All System Registrations</h2>

        <div className="table-wrap">
          <table className="users-table">
            <thead>
              <tr>
                <th>Identity Name</th>
                <th>Communication Email Address</th>
                <th>Clearance Tier</th>
                <th>Administrative Operation</th>
              </tr>
            </thead>

            <tbody>
              {users.map((u) => (
                <tr key={u.id}>
                  <td>
                    <div className="user-name-cell">
                      <div className="table-avatar">
                        {u.name ? u.name.charAt(0).toUpperCase() : "?"}
                      </div>
                      <span>{u.name || "N/A"}</span>
                    </div>
                  </td>

                  <td>{u.email}</td>

                  <td>
                    <span className="role-badge" data-role={u.role || "student"}>
                      {u.role || "student"}
                    </span>
                  </td>

                  <td>
                    <button
                      type="button"
                      className="table-edit-btn"
                      onClick={() => handleEdit(u)}
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center", color: "#94a3b8", padding: "30px" }}>
                    No system records identified in data registry queries.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

    </div>
  );
};

export default UsersPage;